export default "__VITE_ASSET__CJ495w62__"